import React from 'react'
import { Link } from 'react-router-dom'

// crumbs: [{ name, path }]; the last one is the current page and isn't linked.
export const Breadcrumbs = ({ crumbs = [] }) =>
  crumbs.length > 0 && (
    <nav aria-label="Breadcrumb" className="text-sm text-gray-500 mb-2">
      {crumbs.map((crumb, i) => (
        <React.Fragment key={crumb.path}>
          {i > 0 && ' › '}
          {i < crumbs.length - 1 ? <Link to={crumb.path}>{crumb.name}</Link> : crumb.name}
        </React.Fragment>
      ))}
    </nav>
  )

export default Breadcrumbs
